/* Scalapay on-site messaging - the app block renders its widget inside a Shadow
   DOM and exposes no ::part, so no theme CSS reaches it, not even the section's
   custom CSS field. The only way in is to append a <style> to its shadowRoot
   once the custom element is defined.

   What the rules do, measured on the S136 PDP (block goes from 92px to 28px) :
   - .py-4        : kills the 16px of top/bottom padding, and drops the type to
                    12px so the sentence holds on one line - that wrap alone is
                    half the height saved
   - article      : drops the 8px radius, tightens the inside to 4px 8px and
                    pins the line-height to 16px so the strut cannot grow it
   - svg          : Scalapay logo down to 14px, the info chevron down to 12px
   - .rounded-xl  : flattens the small Scalapay logo (12px radius)

   Measured alternatives if the band has to move again : 11px type + 4px 8px
   padding + 13px svg gives 24px (readability floor), 13px + 5px 10px gives 30px.

   Those are Scalapay's own Tailwind classes : if their build renames them the
   widget simply falls back to its default look, nothing on the page breaks.
   The outer <scalapay-widget> tag is NOT in the shadow tree, so its spacing
   stays in assets/peterandmay.css. */
(function () {
  var STYLE_ID = 'pm-scalapay-style';
  var CSS = [
    '.font-scalapay-poppins.py-4 { padding-top: 0 !important; padding-bottom: 0 !important; font-size: 12px !important; }',
    'article { border-radius: 0 !important; padding: 4px 8px !important; gap: 2px !important; font-size: 12px !important; line-height: 16px !important; }',
    'article div, article span { line-height: 16px !important; }',
    'article svg { height: 14px !important; width: auto !important; }',
    'article button svg { height: 12px !important; }',
    '.rounded-xl { border-radius: 0 !important; }'
  ].join('\n');

  var polling = false;

  /* false = the element is there but its shadowRoot is not attached yet */
  function patch(el) {
    var root = el.shadowRoot;
    if (!root) return false;
    if (root.getElementById(STYLE_ID)) return true;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
    return true;
  }

  function run() {
    var widgets = document.querySelectorAll('scalapay-widget');
    var pending = false;
    Array.prototype.forEach.call(widgets, function (el) {
      if (!patch(el)) pending = true;
    });
    return widgets.length > 0 && !pending;
  }

  /* The shadowRoot can land a tick after the element : poll for a few seconds,
     then give up rather than keep a timer alive for the whole session. */
  function retry(left) {
    polling = true;
    if (run() || left <= 0) {
      polling = false;
      return;
    }
    setTimeout(function () {
      retry(left - 1);
    }, 250);
  }

  function schedule() {
    if (!polling) retry(12);
  }

  customElements.whenDefined('scalapay-widget').then(function () {
    schedule();
    /* A variant change re-renders the widget and the cart drawer mounts its own
       copy : anything added later gets the style too. */
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  });
})();
